import * as React from 'react';
import { observer } from 'mobx-react';
import { translation } from '../../i18n';
import { IObservableValue, observable } from 'mobx';
import { ChoiceDto, ChoiceRequest } from '../choiceTypes';
import { emptyValidationErrors, isValidationErrors, ValidationErrors } from '../../api/restApi';
import { Dialog } from '@material-ui/core';
import { DialogTitle } from '@material-ui/core';
import { Spinner } from '../../spinner/Spinner';
import { createPicker } from '../../util/picker';
import { TextField } from '@material-ui/core';
import { renderRemainingErrors, textFieldErrorProps } from '../../util/formUtils';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { isValidChoice } from '../../util/validations';
import { createChoice } from './questionCatalogueApi';

interface Props {
  onClose: () => void;
  onSave: (choice: ChoiceDto) => void;
  open: boolean;
}


@observer
export class NewChoiceDialog extends React.Component<Props, {}> {

  @observable private choice: ChoiceRequest = {description: ''};
  @observable private validationErrors: ValidationErrors = emptyValidationErrors();
  private loading: IObservableValue<boolean> = observable.box(false);

  constructor(props: Props) {
    super(props);
  }

  public render() {
    const errorPicker = createPicker(this.validationErrors.fieldErrors);

    return (
      <Dialog
        id="newChoiceDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">{translation.t('newChoiceDialog.title')}</DialogTitle>
        {
          this.loading.get() ?
            <Spinner/> :
            <>
              <DialogContent>
                <TextField
                  autoFocus={true}
                  id="choice_input_description"
                  label={translation.t('choice.description')}
                  margin="dense"
                  fullWidth={true}
                  value={this.choice.description}
                  onChange={ev => {
                    this.choice.description = ev.target.value;
                  }}
                  required={true}
                  {...textFieldErrorProps(errorPicker.pick(e => e.field === 'description'))}
                />
                {renderRemainingErrors(errorPicker.remaining())}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  this.choice = {description: ''};
                  this.props.onClose();
                }} color="primary">
                  {translation.t('actions.cancel')}
                </Button>
                <Button onClick={() => this.onSaveClicked()} color="primary">
                  {translation.t('actions.save')}
                </Button>
              </DialogActions>
            </>
        }
      </Dialog>
    );
  }

  private onSaveClicked() {
    this.validationErrors = isValidChoice(this.choice);
    if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.loading.set(true);
      createChoice(this.choice).then(
        data => {
          this.loading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = emptyValidationErrors();
            this.props.onSave(data);
            this.choice = {description: ''};
          }
        }
      );
    }
  }
}
